import { render, staticRenderFns } from "./TeamGroup.vue?vue&type=template&id=1322646c&"
import script from "./TeamGroup.vue?vue&type=script&lang=js&"
export * from "./TeamGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports